import React, { useState, createContext, useEffect } from 'react';
import SHA256 from 'crypto-js/sha256';

export const generate_nonce = () => {
  const timestamp = new Date().getTime();
  const timestamp_base64 = Buffer.from(timestamp.toString()).toString('base64');
  const nonce_str = `${process.env.REACT_APP_API_NONCE_PROTECT_KEY}:${timestamp}`;
  const nonce_hash = SHA256(nonce_str).toString();
  return `${timestamp_base64}.${nonce_hash}`;
}

export const NonceProtectContext = createContext();

export const NonceProtectProvider = ({ children }) => {
  const [nonce, setNonce] = useState(generate_nonce());

  useEffect(() => {
    const interval = setInterval(() => {
      setNonce(generate_nonce());
    }, parseInt(process.env.REACT_APP_API_NONCE_PROTECT_REFRESH_INTERVAL_SEC) * 1000);
    return () => clearInterval(interval);
  }, []);
  return (
    <NonceProtectContext.Provider value={nonce}>
      {children}
    </NonceProtectContext.Provider>
  );
};